/**
 * Summary
 * This Modal displays the Introduction / Initial Configuration Wizard
 * form, displayed on the chronicle's first load. Completing this wizard
 * will set a flag on the chronicle, stating that it has all the necessary
 * configuration required to continue editing. This will also serve as an
 * "on-boarding" process, helping new users get started without needing
 * to resort to help channels to get their Chronicles setup.
 */

import React from "react";
import { useSelector } from "react-redux";
import { useModal } from "../_contexts";
import { Modal } from "../_components";
// import { IntroForm } from './forms';
import { ChronicleSetupForm, WelcomeWizard } from "./forms";

export function IntroModal() {
  const { data } = useSelector((state) => state.chronicle);
  // console.log('IntroModal Rendered');
  const { closeModal } = useModal();

  return (
    <Modal
      id="introModal"
      backdrop="static"
      title="New Chronicle Setup"
      icon="fas fa-cogs fa-fw"
      size="lg"
      open
      onClose={() => closeModal()}
      unclosable
      // unscrollable
      noPadding
    >
      {/* {data && <IntroForm chronicle={data} />} */}
      {/* {data && <ChronicleSetupForm chronicle={data} />} */}
      {data && <WelcomeWizard />}
    </Modal>
  );
}
